var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "header",
    { attrs: { id: "header" } },
    [
      _c(
        "v-app-bar",
        { attrs: { color: "primary", dark: "", app: "" } },
        [
          _c("v-toolbar-title", { staticClass: "white--text" }, [
            _vm._v("Kabu"),
          ]),
          _vm._v(" "),
          _c("v-spacer"),
          _vm._v(" "),
          _c(
            "v-toolbar-items",
            [
              _c(
                "v-menu",
                {
                  attrs: { "offset-y": "" },
                  scopedSlots: _vm._u([
                    {
                      key: "activator",
                      fn: function ({ on }) {
                        return [
                          _c("v-btn", _vm._g({ attrs: { text: "" } }, on), [
                            _vm._v("Menu"),
                          ]),
                        ]
                      },
                    },
                  ]),
                },
                [
                  _vm._v(" "),
                  _c(
                    "v-list",
                    [
                      _c(
                        "v-list-item",
                        { attrs: { href: "/" } },
                        [
                          _c(
                            "v-list-item-content",
                            [_c("v-list-item-title", [_vm._v("TOP")])],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-list-item",
                        { attrs: { to: "/home/user_incentives" } },
                        [
                          _c(
                            "v-list-item-content",
                            [_c("v-list-item-title", [_vm._v("優待取得状況")])],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-list-item",
                        { attrs: { to: "/home/crosses" } },
                        [
                          _c(
                            "v-list-item-content",
                            [_c("v-list-item-title", [_vm._v("一般信用残")])],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-list-item",
                        { attrs: { href: "/ipos" } },
                        [
                          _c(
                            "v-list-item-content",
                            [_c("v-list-item-title", [_vm._v("IPO")])],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-list-item",
                        {
                          attrs: {
                            href: "https://www.freebbs.biz/xbrl/index.html",
                          },
                        },
                        [
                          _c(
                            "v-list-item-content",
                            [_c("v-list-item-title", [_vm._v("財務分析")])],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }